
import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../../selectors/access/auth'
import { handleError } from '../../errors/errorManager'
import { showLoader, hideLoader } from '../../../actions/common.js'
import getFleetDocumentDetails from '../../../services/fleets/getFleetDocumentDetails'
import { fetchDocumentDetailsFleetSuccess } from '../../../actions/management/auxModals/auxModals'
import auxModalsTypes from '../../../constants/actions/management/auxModals/auxModals'

export function * fetchDocumentDetailsFleet ({ documentTypeUseId, fleetId, dossierList }) {
  try {
    yield put(showLoader())
    const auth = yield select(getAuth)

    const data = yield call(getFleetDocumentDetails, auth.token, { documentTypeUseId: documentTypeUseId, fleetId: fleetId }, dossierList)
    yield put(fetchDocumentDetailsFleetSuccess(data))
  } catch (error) {
    yield call(handleError, { error })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchfetchDocumentDetailsFleet () {
  yield takeLatest(auxModalsTypes.FETCH_DOCUMENT_DETAIL_FLEET, fetchDocumentDetailsFleet)
}
